<template>
 <div class="row mt-4 mb-2 font-weight-bold" style="font-size: 16px; text-decoration: underline;"> {{ $t('demand.tabs.summary.finacing.label') }}</div>
      <div class="row">
        <div class="col-12">
          <label
            class="d-block font-semi-bold mb-0 font-size color font-weight">
            {{ $t('demand.tabs.summary.finacing.refContract') }}
           
          </label>
          <span class="font-weight margin-left color" v-html="getOfferReference(orderFinancing)">

          </span>
        </div>
    </div>   
     <div class="row">
        <div class="col-12">
          <label
            class="d-block font-semi-bold mb-0 font-size color font-weight">
             {{ $t('demand.tabs.summary.finacing.scale') }}
            
          </label>
          <span class="font-weight margin-left color" >
            {{formattedBareme}}
          </span>
        </div>
    </div>       
</template>

<script lang="ts">
import store from "@/store";
import {Options, Vue} from "vue-class-component";


@Options({
  components: {
  },
})
export default class summaryTabOrderFinancing extends Vue {

  getOfferReference(orderFinancing: any): string {
    const partyName = orderFinancing.associatedParty?.orderParty?.party?.rawData?.responseData?.name?.toLowerCase() || '';
    
    if (partyName.includes("mobilize")) {
      const offerReference = orderFinancing.offerReference ? orderFinancing.offerReference : "-";
      if (offerReference !== "-") {
        const url = `https://dcs.renault.com/cdi/rpj/gererContratBuilderEfficom.do?numContrat=${offerReference}`;
        return `<a href="${url}" target="_blank">${offerReference}</a>`;
      } else {
        return "-";
      }
    }
    return orderFinancing.offerReference ? orderFinancing.offerReference : "-";
  }
  get formattedBareme() {
    const orderFinancing = this.orderFinancing;
    const typeProduit = orderFinancing && 
                        orderFinancing.label 
                        ? orderFinancing.label 
                        : '-'
    const familleBareme = orderFinancing && 
                          orderFinancing.businessData && 
                          orderFinancing.businessData.szFamilleBareme 
                          ? orderFinancing.businessData.szFamilleBareme 
                          : '-';
    const codeBareme = orderFinancing && 
                       orderFinancing.businessData && 
                       orderFinancing.businessData.szCodeBareme 
                       ? orderFinancing.businessData.szCodeBareme 
                       : '-';
    if (typeProduit === '-' && familleBareme === '-' && codeBareme === '-') {
      return '-';
    }
    return `${typeProduit}/${familleBareme}/${codeBareme}`;
  }

  get orderFinancing() {
    return store.getters["orderModule/orderFinancingModule/getOrderFinancing"];
  }
}
</script>

<style scoped>
</style>
